export default __webpack_public_path__ + "static/media/WAS0333.34I-41683_-24963_0.20e9002f.jpg";